const state = () => ({
    _active: 0,
    _initialized: false,
});

const getters = {
    dropdown: (state) => ({ active: state._active, initialized: state._initialized }),
};

const actions = {
    dropdownInit() {
        this._setDropdownInitialized();
    },

    dropdownOpen(uid) {
        this._setDropdownOpened(uid);
    },

    dropdownClose() {
        this._setDropdownClosed();
    },

    _setDropdownInitialized() {
        this._initialized = true;
    },

    _setDropdownOpened(uid) {
        this._active = uid;
    },

    _setDropdownClosed() {
        this._active = 0;
    },
};

export default {
    state,
    getters,
    actions,
};
